import { render, staticRenderFns } from "./CardCdp.vue?vue&type=template&id=201813e8&"
import script from "./CardCdp.vue?vue&type=script&lang=ts&"
export * from "./CardCdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports